import { render, staticRenderFns } from "./SectionTreeView.vue?vue&type=template&id=90143540&"
import script from "./SectionTreeView.vue?vue&type=script&lang=js&"
export * from "./SectionTreeView.vue?vue&type=script&lang=js&"
import style0 from "./SectionTreeView.vue?vue&type=style&index=0&id=90143540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports